module.exports = __webpack_public_path__ + "img/piping_width.c337f964.png";